import { render, staticRenderFns } from "./DraftInvoicePreparer.vue?vue&type=template&id=53c0fd88&scoped=true&"
import script from "./DraftInvoicePreparer.vue?vue&type=script&lang=ts&"
export * from "./DraftInvoicePreparer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0fd88",
  null
  
)

export default component.exports